var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from '@/setup/axios';
import { showLoading } from '@/helpers';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { trans } from '@/setup/locales';
let FileRemover = class FileRemover extends Vue {
    constructor() {
        super(...arguments);
        this.show = true;
    }
    get filename() {
        var _a;
        return (_a = this.file.split('/').pop()) !== null && _a !== void 0 ? _a : '';
    }
    deleteMedia() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!confirm(trans('staffs.remove-media'))) {
                return;
            }
            showLoading(true);
            try {
                const { data: { success } } = yield axios.post(this.route, {
                    _method: 'DELETE'
                });
                this.show = !success;
            }
            catch (error) {
                console.error(error);
            }
            showLoading(false);
        });
    }
};
__decorate([
    Prop()
], FileRemover.prototype, "route", void 0);
__decorate([
    Prop()
], FileRemover.prototype, "file", void 0);
__decorate([
    Prop()
], FileRemover.prototype, "media", void 0);
FileRemover = __decorate([
    Component
], FileRemover);
export default FileRemover;
